import { Component, DestroyRef, inject, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SideService } from '@app/core/layout/side.service';
import { CartService } from '@app/core/services/cart/cart.service';
import { MenuState } from '@app/core/services/menu/state/menu.state';
import { NavigationService } from '@app/core/services/navigation.service';
import { SiteState } from '@app/core/services/site/state/site.state';
import { CartPageSidePanelWrapperComponent } from '@app/features/cart/pages/cart-page-side-panel-wrapper/cart-page-side-panel-wrapper.component';
import { combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { PlaceSelectorDialogResult } from '../place-selector-dialog/place-selector-dialog-result.model';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: false
})
export class TopBarComponent implements OnInit {

  private readonly _destroyRef = inject(DestroyRef);
  orderingIsOpen$ = this._menuState.getCurrentMenu$().pipe(
    takeUntilDestroyed(this._destroyRef),
    map(menu => menu?.orderingSettings?.isOpen)
  );

  cartBadgeValue$ = combineLatest([this._cartService.getCountStandardProducts$(), this.orderingIsOpen$])
    .pipe(
      takeUntilDestroyed(this._destroyRef),
      // display productsCount only if orderingIsOpen
      map(([productsCount, orderingIsOpen]) => (orderingIsOpen && productsCount) || undefined),
      shareReplay({ bufferSize: 1, refCount: true })
    );

  deliveryDate$ = this._cartService.getCurrentCart$().pipe(
    map(cart => cart?.deliveryDate && new Date(cart.deliveryDate))
  );

  displayDeliveryDatePicker$ = this._menuState.getCurrentMenu$().pipe(
    takeUntilDestroyed(this._destroyRef),
    map(menu => menu?.consumptionMode.displayPickupScheduleInput === true),
  );

  isLoading$ = combineLatest([
    this._menuState.isUpdating$(),
    this._siteState.isUpdating$()
  ]).pipe(
    takeUntilDestroyed(this._destroyRef),
    map(([menuIsLoading, siteIsLoading]) => menuIsLoading || siteIsLoading)
  );



  constructor(
    private _menuState: MenuState,
    private _siteState: SiteState,
    private _cartService: CartService,
    private _sideService: SideService,
    private _navigationService: NavigationService,
  ) { }

  ngOnInit(): void {
  }

  onPanelClick() {
    import('../../../features/cart/cart.module').then((m) => {
      this._sideService.toggle();
      this._sideService.setComponent({ component: CartPageSidePanelWrapperComponent, data: null });
    })
  }

  onDeliveryDateChange(selectedDate: Date) {
    this._cartService.updateDeliveryDate(selectedDate);
  }

  onPlaceEdit(event: PlaceSelectorDialogResult) {
    if (event.action === 'ChangeContext') {
      this._navigationService.navigateToMenu$(event.newContext.restaurant).subscribe();
    } else if (event.action === 'GotoSiteSelection') {
      this._navigationService.navigateToSiteSelection();
    }
  }

  onHomeClick() {
    this._navigationService.navigateToDefaultMenu$().subscribe();
  }

  onAccountClick() {
    this._navigationService.navigateToAccount();
  }

}
